export const JSON_CONTENT_TYPE = 'application/json';

export const API_MESSAGES = {
  REAUTH_REQUIRED: 'Please log in again.',
  AUTH_REQUEST_FAILED: 'Authentication request failed.',
  SETUP_REQUEST_FAILED: 'Unable to save setup details.',
  PUBLIC_BOOKING_REQUEST_FAILED: 'Unable to load booking details.',
  CONTACT_REQUEST_FAILED: 'Unable to send your message right now.',
  LOGO_UPLOAD_FAILED: 'Unable to upload logo right now. Please try again.',
  CAMPAIGN_IMAGE_UPLOAD_FAILED: 'Unable to upload campaign image.',
} as const;
